import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ICompany} from "../models/company";
import {ServerEndpoints} from "../../../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class CompanyHttpService {

  constructor(private http: HttpClient, @Inject("BASE_URL") private base: string) {
  }

  load(id: string): Observable<ICompany> {
    return this.http.get<ICompany>(`${this.base}${ServerEndpoints.Management_Company_$id$_v2025_4.dictReplace({id: id})}`);
  }

  all(): Observable<ICompany[]> {
    return this.http.get<ICompany[]>(`${this.base}${ServerEndpoints.Management_Company__v2025_4}`);
  }

  upsert(company: ICompany): Observable<ICompany> {
    return this.http.put<ICompany>(`${this.base}${ServerEndpoints.Management_Company__v2025_4}`, company);
  }
}
